export default {
  authenticated: null,
  profile: {},
  loading: false,
};
